import { useNavigate, useParams } from "react-router-dom";
import { Messages } from "primereact/messages";
import { useEffect, useRef, useState } from "react";
import { ServiceCard } from "../components/ServiceCard";
import {
    GetServiceStatus,
    GetServiceErrors
} from "../services/GetServiceStatus";
import { IServiceEvent } from "../types/IServiceEvent";
import { Spinner } from "@idwal/idwal-react-components";
import { IParentService } from "../types/IParentService";
import { IdwalServices } from "../config/services";

const ServiceStatusPage = () => {
    const navigate = useNavigate();
    const { id } = useParams() as { id: string };

    const [events, setEvents] = useState<IServiceEvent[] | null>(null);
    const [errors, setErrors] = useState<IServiceEvent[] | null>(null);
    const [service, setService] = useState<IParentService | undefined>(
        undefined
    );

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const messages = useRef<any>(null);

    useEffect(() => {
        async function getData() {
            if (id) {
                const data = await GetServiceStatus(id);
                const eventErrors = GetServiceErrors(data);
                setEvents(data);
                setErrors(eventErrors);
                setService(
                    IdwalServices.find((pService) => pService.id === id)
                );
            }
        }
        getData();
        const interval = setInterval(function () {
            getData();
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (messages && messages.current) {
            if (errors && errors.length > 0) {
                messages.current.show([
                    {
                        severity: "error",
                        summary:
                            "This service has errors. Please see the issues and action accordingly.",
                        sticky: true
                    }
                ]);
            }
        }
    }, []);

    return (
        <div className="flex flex-column py-4">
            <div
                onClick={() => navigate("/")}
                className="flex align-items-center cursor-pointer select-none link-hover"
            >
                <i
                    className="pi pi-arrow-circle-left pr-1"
                    style={{ fontSize: "1em" }}
                ></i>
                <small style={{ marginTop: 2 }}>Back to services</small>
            </div>

            <Messages className="mt-2" ref={messages} />

            {service && events && errors ? (
                <>
                    <h1 className="mt-3">{service.name}</h1>

                    {service.services.map((s) => {
                        return (
                            <ServiceCard
                                key={s.parentId}
                                parentService={service}
                                events={events.filter((event) => {
                                    return event.serviceKey === s.name;
                                })}
                                errors={errors.filter((error) => {
                                    return error.serviceKey === s.name;
                                })}
                                service={s}
                            />
                        );
                    })}
                </>
            ) : (
                <div className="mt-5">
                    <Spinner width={50} height={50} />
                </div>
            )}
        </div>
    );
};

export default ServiceStatusPage;
